import axios from 'axios';

//const dataFileName = "./data/nwis_current.json";

// constant part of current year series definition
let crnt_series = {
  type: "scatter",
  lineWidth: 0,
  marker: {
    symbol: 'circle',
    lineColor: "black",
  },
  tooltip: {
    valueDecimals: 2,
    headerFormat: '<b>{series.name}</b><br/>',
    pointFormat: '{point.x:%B %e}: {point.y} feet',
  },
  zIndex: 3
};

// create scatter plot of current year values - accepted and provisional separately
const fill_graph = (results_data, datelist, chart) => {
  // actual start/end year for graph legend
  const today = new Date();
  const actual_start_year = today.getMonth() != 11 ? today.getFullYear() - 1 : today.getFullYear();
  const actual_end_year = today.getFullYear();
  const actual_yr_str = actual_start_year === actual_end_year ? actual_start_year : (actual_start_year + "-" + actual_end_year);

  const newSeries= [];
  const items_a = [];
  const items_p = [];
  datelist.forEach(d => {
    var ny, nm, nd, date_key;
    ny = d.getMonth() > today.getMonth() ? today.getFullYear()-1 : today.getFullYear()
    nm = (d.getMonth()+1).toString().padStart(2, '0')
    nd = (d.getDate()).toString().padStart(2, '0')
    date_key = ny + "-" + nm + "-" + nd
    if (results_data[date_key]) {
      if (results_data[date_key][1] === "A") {
        items_a.push([d.getTime(), results_data[date_key][0]])
      } else if (results_data[date_key][1] === "P") {
        items_p.push([d.getTime(), results_data[date_key][0]])
      }
    }
  })
  // fairly continuous series has smaller markers with no line around the marker
  const continuous = (items_p.length + items_a.length) > 24; 
  crnt_series.marker = {...crnt_series.marker, radius: continuous ? 3 : 4, lineWidth: continuous ? 0 : 0.5 }
  // add two scatters to graph
  if (items_a.length > 0) {
    newSeries.push({...crnt_series, name: actual_yr_str + ' (approved)', data: items_a, color: "black", legendIndex: 1});
  }
  if (items_p.length > 0) {
    newSeries.push({...crnt_series, name: actual_yr_str + ' (provisional)', data: items_p, color: "gray", legendIndex: 2})
  }
  newSeries.forEach(ns => { chart.addSeries(ns) })
  
  return newSeries
};

const add_stnName_subtitle = (name, chart) => {
  // backup station name; used primarily for graphs with only current data (no percentiles)
  if (name && chart.subtitle.textStr == '.') {
      chart.subtitle.textStr = name;
      chart.redraw();
  }
};

const fetchData = (dataFileName, stnid, datelist, chart) => {
    axios.get(dataFileName)
        .then(results => {
            if (results.data[stnid]) {
              fill_graph(results.data[stnid], datelist, chart);
              add_stnName_subtitle(results.data[stnid].name, chart);
            }
        })
        .catch(err => {
            console.log(err.message);
        });
};

export const fill_graph_crntyr = (dataFileName, stnid, datelist, chart) => {
    fetchData(dataFileName, stnid, datelist, chart);
}